<template lang="html">
    <div class="error-page">
        <div class="error-page__image">
            <img src="@/assets/images/404-image.png">
        </div>
        <div class="error-page__title">
            Ne pare rau, nu am putut gasi această pagină.
        </div>
        <div class="error-page__button" @click="$router.back()">
            Înapoi
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
@import  "@/scss/pages/_error-page.scss";
</style>
